import React, { ReactNode, useMemo, useRef } from 'react'

import { useInView } from 'framer-motion'

import { TRANSITION } from 'Constants/Animations'

import { Container } from './styles'

type Props = {
  children: ReactNode
  kind?: 'upward' | 'expand'
  centered?: boolean
}

function AppearingWrapper({ centered, children, kind = 'upward' }: Props) {
  const ref = useRef(null)
  const isInView = useInView(ref, { once: true })

  const { animate, initial, style, transition } = useMemo(() => {
    if (kind === 'expand')
      return {
        animate: isInView ? { scale: 1, opacity: 1 } : {},
        initial: { scale: 0.3, opacity: 0 },
        style: {
          ...(centered && { justifyContent: 'center' }),
        },
        transition: TRANSITION.APPEARING_EXPAND,
      }

    return {
      animate: isInView ? { opacity: 1, y: 0 } : {},
      initial: { opacity: 0, y: 20 },
      style: { ...(centered && { justifyContent: 'center' }), width: '100%' },
      transition: TRANSITION.APPEARING_UPWARD,
    }
  }, [centered, isInView, kind])

  return (
    <Container
      animate={animate}
      initial={initial}
      ref={ref}
      style={style}
      transition={transition}
    >
      {children}
    </Container>
  )
}

export default AppearingWrapper
